import { Fragment } from "react";
import ExcelFileIcon from "./ExcelFileIcon";

const ReportToolbar = (props: ToolbarProps) => {
    return (
        <Fragment>
            <div onClick={props.export}>
                <ExcelFileIcon
                    color="primary"
                    fontSize='large'
                    viewBox='100 0 300 550'
                    sx={{
                        "&:hover": {
                            cursor: 'pointer',
                        },
                        color: '#04AA6D',
                        marginTop: '1rem',
                    }}
                />
            </div>
        </Fragment>
    );
}

interface ToolbarProps {
    export: () => void;
}

export default ReportToolbar;